// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3lK5v","modalFooterButton":"ModalNotes_modalFooterButton__325iF"};